export enum HeadersEnum {
  SuppressLogErrors = 'suppress-log-errors',
}
